<div class="aya-session-breaks">
  <div class="aya-title">Session breaks</div>
  <div class="aya-subtitle">{{ sessionBreaksBySchool?.sessionBreaksInfo }}</div>
  <div class="aya-session-breaks__table">
    <p-table [value]="sessionBreaksBySchool?.breaks">
      <ng-template pTemplate="header">
        <tr>
          <th>Start date</th>
          <th *ngFor="let column of columns">{{ column?.orderLabel }} ({{ column?.durationLabel }})</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-sessionBreak>
        <tr>
          <td>{{ sessionBreak.courseStartDate | lxOrdinalDate }}</td>
          <td *ngFor="let holidayStartDateColumn of columns">
            <ng-container *ngFor="let holidayStartDate of sessionBreak?.holidayStartDates">
              <span *ngIf="holidayStartDate?.order === holidayStartDateColumn?.order">
                {{ holidayStartDate?.date | lxOrdinalDate }}
              </span>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
